<template>
  <div class="c-container" :style="style">
    <div class="c-container-map">
      <slot name="map"></slot>
    </div>
    <!--    <div class="c-container-shadow"></div>-->
    <div class="c-container-main">
      <div class="main-header">
        <div class="main-header-left">
          <div style="display: flex; align-items: center">
<!--            <img-->
<!--              src="@/assets/icon/horn.png"-->
<!--              alt=""-->
<!--              style="margin-right: 20px"-->
<!--            />-->
            <Alert @on-position="onPosition" @on-change-mn="onChangeMn" v-if="showAlert" style="margin-right: 20px; z-index: 8" />

<!--            <Icon-->
<!--                v-if="showAlert"-->
<!--                class="close"-->
<!--                type="md-close"-->
<!--                size="48"-->
<!--                style="margin-right: 20px;-->
<!--              z-index: 999999;-->
<!--              pointer-events: auto;-->
<!--            "-->
<!--                @click="showAlert = false"-->
<!--            />-->
            <!--            重要通知，某某监测点流量异常，请注意！-->
          </div>
        </div>
        <h5>{{ title }}</h5>
        <div class="main-header-right">
          <iframe
            allowtransparency="true"
            frameborder="0"
            width="200"
            height="36"
            scrolling="no"
            src="//tianqi.2345.com/plugin/widget/index.htm?s=3&z=3&t=1&v=0&d=3&bd=0&k=000000&f=ffffff&ltf=009944&htf=cc0000&q=1&e=0&a=0&c=70939&w=180&h=36&align=center&fontSize=24"
          ></iframe>
          <div>{{ dayjs().calendar() }}</div>
          <div class="time">{{ now }}</div>
        </div>
      </div>
      <div class="main-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import calenderPlugin from "dayjs/plugin/calendar";
import updateLocale from "dayjs/plugin/updateLocale";
import Navigation from "@/components/Navigation.vue";
import Alert from "@/components/alert/Alert.vue";
dayjs.extend(updateLocale);
dayjs.extend(calenderPlugin);
dayjs.updateLocale("zh-cn", {
  calendar: {
    sameDay: "YYYY[年]MM[月]DD[日] dddd",
  },
});
dayjs.locale("zh-cn");
export default {
  name: "Container",
  components: { Navigation, Alert},
  props: {
    background: {
      type: String,
      default: require("@/assets/images/bg.png"),
    },
    title: {
      type: String,
      default: "江夏区城市运营调度大屏",
    },
  },
  data() {
    return {
      showAlert:true,
      height: 2160,
      width: 3840,
      bodyHeight: document.body.offsetHeight,
      bodyWidth: document.body.offsetWidth,
      now: dayjs().format("HH:mm:ss"),
      timer: null,
    };
  },
  computed: {
    dayjs() {
      return dayjs;
    },
    style() {
      const bodyHeight = this.bodyHeight;
      const bodyWidth = this.bodyWidth;
      let scaleH = 1,
        scaleW = 1;
      // if (this.width >= bodyWidth) {
      scaleW = bodyWidth / this.width;
      // }

      if (this.height > bodyHeight / scaleW) {
        scaleH = bodyHeight / scaleW / this.height;
      }
      return {
        height: 100 + "vh",
        width: 100 + "vw",
        // transform: `scale(${scaleW * scaleH})`,
      };
    },
  },
  methods: {
    onPosition(id){
      this.$emit('onPosition',id)
    },
    onChangeMn(value){
      this.$emit('onChangeMn',value)
    }
  },
  mounted() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.bodyHeight = document.body.offsetHeight;
        this.bodyWidth = document.body.offsetWidth;
      });
    };
    this.timer = setInterval(() => {
      this.now = dayjs().format("HH:mm:ss");
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
.c-container {
  background-size: 100% 100%;
  overflow: hidden;
  position: absolute;

  &-main {
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    bottom: 0;
    z-index: 50;
    display: flex;
    flex-direction: column;

    .main-header {
      display: flex;
      height: 70px;
      padding: 0 30px;
      font-size: 20px;
      justify-content: space-between;

      h5 {
        margin: 10px 0 0;
        pointer-events: auto;
        letter-spacing: 6px;
        font-size: 30px;
        font-family: sans-serif;
        font-weight: bold;
        text-shadow: 0 0 23px rgba(48, 157, 241, 0.8);
        line-height: 50px;
      }

      &-left,
      &-right {
        width: 30%;
      }

      &-right {
        display: flex;
        align-items: center;
        height: 36px;
        justify-content: flex-end;

        .time {
          width: 100px;
          font-size: 20px;
          font-family: sans-serif;
          font-weight: bold;
          color: #ffffff;
          text-shadow: 0 0 23px rgba(48, 157, 241, 0.8);
          margin-left: 20px;
          text-align: right;
        }
      }
    }

    .main-body {
      flex: 1;
      overflow: hidden;
      position: relative;
    }
  }
  &-map {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    //z-index: 0;
  }

  &-shadow {
    background-image: url("../assets/images/shadow.png");
    background-size: 100% 100%;
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    bottom: 0;
  }
}
</style>
